import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Roles } from '../constants';
import { areUserRolesIn } from '../helpers';

import type { RootState } from '../store';

const useReadOnlyTimesheetView = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const isReadOnlyView = useMemo(() => {
    if (!user) return false;

    return !areUserRolesIn(user?.roles, [Roles.Bcba, Roles.Prbt, Roles.Vbt]);
  }, [user]);

  return isReadOnlyView;
};

export default useReadOnlyTimesheetView;
